import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import UserRoleForm from "./_userRoleForm";
import { IUserRoleFormInput, IUserRoleUpdateProps } from "./UserRole.model";
import { userRoleService } from "../../service/UserRole/userRole.service";

const UserRoleUpdate = ({
  data,
  setUserRoleDialog,
  loadUserRoles,
}: IUserRoleUpdateProps) => {
  const [id, setId] = useState<number | null>(null);

  const methods = useForm<IUserRoleFormInput>({
    defaultValues: {
      name: "",
    },
  });

  useEffect(() => {
    if (data) {
      setId(data.id);
      methods.reset({
        name: data.name,
      });
    }
  }, [data, methods]);

  const onSubmit = async (values: IUserRoleFormInput) => {
    if (!id) return;

    await userRoleService.update(id, values);
    loadUserRoles();
    setUserRoleDialog(false);
  };

  return <UserRoleForm methods={methods} onSubmit={onSubmit} isEdit={true} />;
};

export default UserRoleUpdate;
